import React from 'react';
import colors from 'shared-components/theme/colors';
import { gilroyMedium, gilroyRegular, gilroySemibold } from 'shared-components/theme/fonts';
import Media from 'shared-components/theme/medias';
import styled from 'styled-components';
const IntroductionDesc = ({ desc, textColor }) => {
    return (
        <Desc
            textColor={textColor}
            dangerouslySetInnerHTML={{ __html: desc }}></Desc>
    );
};

export default IntroductionDesc;

const Desc = styled.p`
    font-size: 18px;
    color: ${(props) => props.textColor || colors.geoWhite[100]};
    font-family: ${gilroyRegular};
    font-weight: 400;
    b {
        font-weight: 600;
        font-family: ${gilroySemibold};
    }
    ${Media('large')} {
        font-size: 1.19vw;
    }
    @media (max-width: 1024px) {
        font-size: 16px;
    }
    ${Media('mobile')} {
        font-size: 14px;
    }
`;
